// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2gKCP","infoBtn":"quickbooks_infoBtn__1gZpZ","formBox":"quickbooks_formBox__2mCV3","formFooter":"quickbooks_formFooter__3Rrfh"};